import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { firebaseAuth } from 'config/constants'
import RaisedButton from "material-ui/RaisedButton";
import Subheader from "material-ui/Subheader";
import Dialog from "material-ui/Dialog";

import * as accounts_actions from "data/accounts/actions";
import * as profile_actions from "data/profile/actions";

import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";

import Row from "components/Form/Row";
import Field from "components/Form/Field";

class UserProfile extends Component {
  state = {
    sms: false
  };

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchUserProfile(this.props.fbuser.uid);
  }

  handleFormSubmit(event) {
    var account = {};
    account.orgnum = this.refs.orgnum.state.value || "";
    account.orgname = this.refs.orgname.state.value || "";
    account.orgemail = this.refs.orgemail.state.value || "";
    account.orgphone = this.refs.orgphone.state.value || "";
    account.street = this.refs.street.state.value || "";
    account.zip = this.refs.zip.state.value || "";
    account.city = this.refs.city.state.value || "";
    this.props.actions.updateAccount(
      this.props.account.info.accountid,
      account
    );
  }

  handleClose = () => {
    this.setState({sms: false});
  };

  handleSmsVerification = () => {
    this.setState({sms: true});
  }

  sendSmsCodeDone = () => {
  }    
  sendSmsCode = () => {
    console.log(firebaseAuth);
    console.log(firebaseAuth().RecaptchaVerifier);
    window.recaptchaVerifier = new firebaseAuth.RecaptchaVerifier('sign-in-button', {
      'size': 'invisible',
      'callback': function(response) {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        this.sendSmsCodeDone();
      }
    });
    }

  renderAccount(account) {
    var { orgname, orgphone, orgemail, orgnum, street, zip, city } = account;

    return (
      <PageSection>
        <Row>
          <Field
            floatingLabelText="Organisationsnummer"
            ref="orgnum"
            value={orgnum}
          />
        </Row>
        <Row>
          <Field
            floatingLabelText="Företagsnamn"
            ref="orgname"
            value={orgname}
          />
        </Row>
        <Row>
          <Field
            floatingLabelText="E-postadress"
            ref="orgemail"
            value={orgemail}
          />
        </Row>
        <Row>
          <Field floatingLabelText="Telefon" ref="orgphone" value={orgphone} />
        </Row>
        <Row>
          <Field floatingLabelText="Gatuadress" ref="street" value={street} />
        </Row>
        <Row>
          <Field floatingLabelText="Postnummer" ref="zip" value={zip} />
        </Row>
        <Row>
          <Field floatingLabelText="Postort" ref="city" value={city} />
        </Row>
      </PageSection>
    );
  }
  render() {
    var { email, phone } = this.props.fbuser;

    var verification = (
      <Row>
        <RaisedButton primary={true} label="Skicka verifieringsmail!" />{" "}
        &nbsp; <RaisedButton primary={true} label="Ändra lösenord" />{" "}
        &nbsp; <RaisedButton onClick={this.handleSmsVerification} primary={true} label="SMS vertifikation" />{" "}
      </Row>
    );
    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Profil" />
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <div onSubmit={this.handleFormSubmit.bind(this)}>
          <PageBlock header={true} label="Din profil">
            <PageSection>
            <Row>
            <Field
              readonly
              floatingLabelText="E-post"
              ref="email"
              value={email}
            />
          </Row>
          <Row>
                <Field
                  readonly
                  floatingLabelText="Mobilnummer"
                  ref="phone"
                  value={phone}
                />
              </Row>
          {verification}
            </PageSection>
            {this.props.account && this.renderAccount(this.props.account)}
            <PageSection label="">
              <Row styleName="padded">
                <RaisedButton
                  onTouchTap={this.handleFormSubmit.bind(this)}
                  primary={true}
                  label="Spara"
                />
              </Row>
            </PageSection>
          </PageBlock>
        </div>
        <Dialog title="SMS kontoverifiering"
          modal={false}
open={this.state.sms} onRequestClose={this.handleClose}>
          SMS vertifikation
          <RaisedButton onClick={this.sendSmsCode} primary={true} label="Skicka sms kod" />{" "}
          
        </Dialog>
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  if (!state.profile || !state.profile.info) {
    return { fbuser: ownProps.user };
  }
  return {
    fbuser: ownProps.user,
    user: state.profile.info,
    account: state.profile,
    pending: !state.profile.info
  };
}
const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...accounts_actions, ...profile_actions },
      dispatch
    )
  };
};
export default connect(mapStateToProps, mapDispatch)(UserProfile);



// WEBPACK FOOTER //
// ./src/pages/profile/UserProfile.jsx